import React from 'react';
import { connect } from 'react-redux';
import * as appSelectors from '../../../../selectors';

import UgcVisualization from './UgcVisualization.component';

const mapStateToProps = state => ({
	messages: appSelectors.submission.messagesSelector(state),
	focussed: appSelectors.submission.focussedSelector(state),
	selected: appSelectors.submission.selectedSelector(state),
	itemToRemove: appSelectors.submission.itemToRemoveSelector(state),
});

export default connect(
	mapStateToProps
)(UgcVisualization);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/UgcVisualization.container.js